const receipt = () => import('@/views/main/receipt/receipts/receipt.vue')
export default {
  path: '/main/receipt/receipts',
  name: 'receipt',
  component: receipt,
  children: []
}
